/**
 * 등록:File 객체, 이미 등록되어있는 주소: string URL
 * 분류하여 반환
 * @param items Array containing File objects and string URLs
 * @returns Object containing `files` (File[]) and `paths` (string[])
 */
export const separateFilesAndPaths = (
  items: (File | string)[],
): { files: File[]; paths: string[] } => {
  // 결과 저장 배열
  const files: File[] = [];
  const paths: string[] = [];

  // items 배열을 순회하면서 File과 string 구분
  items.forEach((item) => {
    if (item instanceof File) {
      files.push(item); // File 객체는 files 배열에 추가
    } else if (typeof item === 'string') {
      paths.push(item); // string은 paths 배열에 추가
    }
  });
  return { files, paths };
};

/**
 * 단일 값(File 객체 또는 URL)을 분류하여 반환
 * @param item File 객체 또는 string URL
 * @returns Object containing `files` (File[]) and `paths` (string[])
 */
export const separateSingleFileOrPath = (
  item: File | string,
): { file: File | null; path: string | null } => {
  let file: File | null = null; // 단수 File
  let path: string | null = null; // 단수 string

  // 문자열인 경우
  if (typeof item === 'string') {
    path = item; // string 값 할당
  }
  // File 객체인 경우
  else {
    file = item; // File 값 할당
  }

  return { file, path };
};
